<template>
    <config-section
        :title="$t('auth.edit_password')"
        :description="$t('auth.password_description')"
    >

        <simple-input class="w-full mb-16" type="password" v-model="form.current_password">
            {{ $t('auth.current_password') }}:
        </simple-input>

        <simple-input class="w-full mb-16" type="password" v-model="form.password">
            {{ $t('auth.new_password') }}:
        </simple-input>

        <simple-input class="w-full" type="password" v-model="form.password_confirmation">
            {{ $t('auth.password_confirm') }}:
        </simple-input>

        <div v-if="hasErrors" class="mb-16 self-start">
            <ul class="text-semantic-error text-body-sm">
                <li v-for="(error, index) in allErrors" :key="index" class="flex items-center">
                    <svg-icon type="warning" class="max-w-12 max-h-12 mr-4"></svg-icon>
                    <span>{{ error }}</span>
                </li>
            </ul>
        </div>

        <template #buttons>
            <simple-button
                :disabled="!form.isDirty()"
                display="secondary"
                icon="save"
                :loading="form.submitting"
                look="primary"
                @click="save"
            >{{ $t('auth.change_my_password') }}</simple-button>
        </template>

    </config-section>
</template>

<script>
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../state/modules/authentication';
import {useNotificationsStore} from '../state/modules/notifications';
import { ADD_NOTIFICATION } from '../state/mutation-types';
import Form from '../etc/forms/Form';
import SimpleButton from './ui/SimpleButton.vue';
import values from 'lodash/values';
import flatten from 'lodash/flatten';
import Input from './forms/Input.vue';
import * as users from '../services/UserService';
import User from '../models/User';
import { normalizeJson } from '../../shared/helpers';
import ConfigurationSection from './ConfigurationSection.vue';
import SvgIcon from './ui/SvgIcon.vue';

export default {
    components: {
        'config-section': ConfigurationSection,
        'simple-button': SimpleButton,
        'simple-input': Input,
        'svg-icon': SvgIcon,
    },
    data: function () {
        return {
            form: new Form([
                { name: 'current_password', value: '', rules: ['required'] },
                { name: 'password', value: '', rules: ['required']},
                { name: 'password_confirmation', value: '', rules: ['required']},
            ]),
        }
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentUser']),
        hasErrors () {
            return values(this.form.errors).some(errors => errors !== undefined);
        },
        allErrors () {
            return flatten(values(this.form.errors).filter(error => error && error.length));
        },
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        save () {
            return this.form.submit(data => users.updatePassword(this.currentUser.id, {
                data: { attributes: data }
            })).then(result => {
                return useRepo(User).save(normalizeJson(result));
            }).then(user => {
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('general.subject_updated', { subject: this.$t('auth.password') }),
                });
                this.$emit('close');
            })
        }
    }
}
</script>
